import { Injectable } from '@angular/core';
import { StateWithCity } from '@city/data-access';
import { CookieService } from '@core/feature';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { MyShopActions } from '../store/actions';
import { StateWithMyShop } from '../store/my-shop-state';
import { MyShopSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class MyShopFacade {
  constructor(
    private store: Store<StateWithMyShop | StateWithCity>,
    private cookieService: CookieService,
  ) {}

  getMyShopName(): Observable<string | undefined> {
    return this.store.pipe(
      select(MyShopSelectors.getMyShopInit),
      filter((init) => init),
      switchMap(() => this.store.pipe(select(MyShopSelectors.getMyShopName))),
    );
  }

  setMyShopName(name: string | undefined): void {
    this.store.dispatch(new MyShopActions.SetMyShopName(name));
    const expires = new Date();
    expires.setDate(expires.getDate() + 90);
    this.cookieService.put('myShopCookieName', name, { path: '/', expires: expires });
  }

  /**
   * Инициализирует мой магазин, например в persistance service,
   * Дает понять, что после этого действия можно получать имя моего магазина.
   */
  initMyShop(): void {
    this.store.dispatch(new MyShopActions.InitMyShop());
  }

  /**
   * Обратите внимание: когда мы обновляем или удаляем куки, нам следует использовать
   * только такие же настройки пути и домена, как при установке куки.
   */
  removeMyShop(): void {
    this.store.dispatch(new MyShopActions.SetMyShopName(undefined));
    this.cookieService.remove('myShopCookieName', { path: '/' });
  }
}
